export const HOURS = 24;
export const MINUTES = 60;
export const SECONDS = 60;
export const MILLISECONDS = 1000;
export const MS_TO_HOUR = 3600000; // 60 * 60 * 1000
export const MILLISECONDS_IN_MINUTE = 60000;

export const ERROR_DATE = '0001-01-01T00:00:00Z';

export const ONE_DAY = MILLISECONDS * SECONDS * MINUTES * HOURS;

export const END_OF_DAY = {
    hours: 23,
    minutes: 59,
    seconds: 59,
    milliseconds: 999
};

// Used for string slicing to ensure two-digit format
export const TIME_ADJUST_NUMBER = -2;

export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY, HH:mm'
    },
    display: {
        dateInput: 'DD/MM/YYYY, HH:mm',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

export const TIME_SLICE_END_INDEX = 5;
export const TIME_SLICE_START_INDEX = 0;

export const STRING_DATE_BEFORE_TIME_ZONE_LENGTH = 19;